export default "__VITE_ASSET__AfMwBQ$m__"